import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Contact.module.scss';
import emailjs from '@emailjs/browser';
import WHCButton from '../../components/WHCButton/WHCButton';
import { Mail } from "lucide-react";
import HeroSlider from '../../components/HeroSlider/HeroSlider';

import img3 from "../../assets/HeroSlider/hero3.jpg";
import img4 from "../../assets/HeroSlider/hero4.jpg";
import img2 from "../../assets/HeroSlider/hero2.jpg";

const images = [
    img3, img4, img2
]

const Contact = () => {
    const { t } = useTranslation();
    const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

    const [form, setForm] = useState({ name: '', email: '', message: '' });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('Form submitted:', form);
        // TODO: integrate with EmailJS or backend
        emailjs
            .send(
                SERVICE_ID,
                TEMPLATE_ID,
                form,
                PUBLIC_KEY
            )
            .then(() => {
                alert(t('contact_thanks'));
                setForm({ name: '', email: '', message: '' });
            })
            .catch((error) => {
                console.error('EmailJS error:', error);
                alert(t('contact_error'));
            });


    };

    return (
        <section className={styles.contact}>
            <HeroSlider
                label={t('hero_slider_contact')}
                images={images}
            />
            <div className={styles.container}>
                <h1>{t('contact_title')}</h1>
            
                <form onSubmit={handleSubmit}>
                    <label>
                    {t('contact_name')}
                    <input type="text" name="name" value={form.name} onChange={handleChange} required />
                    </label>

                    <label>
                    {t('contact_email')}
                    <input type="email" name="email" value={form.email} onChange={handleChange} required />
                    </label>

                    <label>
                    {t('contact_message')}
                    <textarea name="message" rows="5" value={form.message} onChange={handleChange} required />
                    </label>

                    <WHCButton variant='primary' size='lg' icon={Mail} type="submit">{t('contact_submit')}</WHCButton>
                </form>
            </div>
        </section>
    );
};

export default Contact;
